import { useState, useEffect } from 'react';
import axios from 'axios';
import {v4} from 'uuid'
import { MetaPixel } from '../Facebook';
import {db} from '../firebase'
import {addDoc, collection, doc, getDocs, updateDoc, getDoc, setDoc} from 'firebase/firestore'
import useLabForm from '../hooks/useLabForm';
import { BASE_URL, checkLabSoldout, roundValor } from '../utils/Scripts'
import { useIsMobile } from '../context/MobileContext';
import { lab_list, LabItem, Orders, webInfo } from '../utils/types';
import FibraFotos from './FibraFotos';
import BasicInfo from './BasicInfo';
import Bonus from './Bonus';
import MainForm from './MainForm';
import Faq from './Faq';
import PixPayment from './PixPayment';
import CardPayment from './CardPayment';

export function ArcalabInscricao(props:any){

    const {online, setOnline, selectedId, setSelectedId}:any = useLabForm()

    const [pix, setPix] = useState(true)
    const [cupons, setCupons] = useState<{ name: string; value: number }[]>([])
    const [cupom, setCupom] = useState(props.cupom!=undefined?props.cupom:'')
    const [cupomState, setCupomState] = useState((props.cupom) in cupons?1:0)
    const [preco, setPreco] = useState('0')
    const [display, setDisplay] = useState(0)
    // const [customerInfo, setCustomerInfo] = useState({nome:'', email:'', cpf:''})
    const [payload, setPayload] = useState('')
    const [pixDocId, setPixDocId] = useState('')
    const [labData, setLabData] = useState<Partial<lab_list[0]>[]>([])
    const [activeLabs, setActiveLabs] = useState<Partial<lab_list[0]>[]>([])
    const [webInfo, setWebInfo] = useState<webInfo>({
        cupons: [],
        faq: [],
        taxas: []
    })
    const [nome, setNome] = useState('')
    const [cpf, setCpf] = useState('')
    const [email, setEmail] = useState('')
    const [allSoldout, setAllSoldout] = useState(false)

    const isMobile = useIsMobile()

    async function getLabs(){
        const snapshot = await getDoc(doc(db, 'arcalab_utils', 'lab_list'))
        let data:any = snapshot.data()
        setLabData(data.lab_list)
    }

    async function getWebInfo(){
        try {
            const res = await getDoc(doc(db, 'arcalab_utils', 'web_info'))
            if (res.data()) {
                setWebInfo(res.data() as webInfo)
            }
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(()=>{
        if(labData.length>0){
            const newActiveLabs = labData?.filter(item => item?.active) || []   
            if(newActiveLabs.length>0){
                setActiveLabs(newActiveLabs)
                // setSelectedId(newActiveLabs[0]!.id)
            }
        }
    },[labData])

    useEffect(()=>{
        if(activeLabs.length>0){
            for(let a=0;a<activeLabs.length;a++){
                if(!checkLabSoldout(activeLabs[a] as LabItem, true)){
                    setSelectedId(activeLabs[a].id)
                    break
                } else if(!checkLabSoldout(activeLabs[a] as LabItem, false)){
                    setSelectedId(activeLabs[a].id)
                    setOnline(false)
                    break
                }
                if(a===activeLabs.length-1){
                    setAllSoldout(true)
                }
            }
        }
    },[activeLabs])

    useEffect(()=>{
        getLabs()
        getWebInfo()
    },[])

    useEffect(()=>{
        if(webInfo.cupons){
            setCupons(webInfo.cupons)
        }
    },[webInfo])

    useEffect(()=>{
        goCupom(props.cupom)
    },[cupons])

    useEffect(()=>{
        if(labData.length>0){
            let total = 0
             if(online){
                total = labData.filter((lab:any)=>lab.id==selectedId)[0]?.price_online || 0
            } else {
                total = labData?.filter((lab:any)=>lab.id==selectedId)[0]?.price_presencial || 0
            }
            if(!pix){
                total = total*webInfo?.taxas[0]
            }
            if(cupomState==1){
                total = total*(1-((cupons.find(c => c.name === cupom)?.value ?? 0)/100))
            }
            setPreco(roundValor(total))       
        }
    },[online, pix, cupomState, selectedId])

    function goCupom(text:string){
        if(cupons.some(c => c.name === text)){
            setCupomState(1)
            setCupom(text)
        } else {
            setCupomState(2)
        }
    }

    useEffect(()=>{
        if(display===1){
            let order:Orders = {
                payment_id: v4(),
                nome:nome,
                email:email,
                cpf: cpf,
                online: online,
                pix: pix,
                valor:Number(preco),
                data: new Date().toJSON().slice(0,10),
                cupom: cupom,
                lab_id: selectedId,
                status:'pending'
            }

            const options = {
                url:BASE_URL+'payment_pix',
                method:'POST',
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json',
                },
                data:{
                    order: order
                }
              }
              axios.request(options)
              .then((res)=>{
                    const {payload, doc_id} = res.data
                    setPayload(payload)
                    setPixDocId(doc_id)
              })
        }
    },[display])


    return(
        <div>
            <MetaPixel/>
            <div style={{width:isMobile?'100%':'700px', margin:'5vh auto'}}>
                    <BasicInfo width={props.width} activeLabs={activeLabs}/>
                    <Bonus/>
                    {display==0&&(
                        <MainForm
                        setDisplay={setDisplay}
                        labData={labData}
                        cupomState={cupomState}
                        setCupomState={setCupomState}
                        cupom={cupom}
                        setCupom={setCupom}
                        preco={preco}
                        pix={pix}
                        goCupom={goCupom}
                        nome={nome}
                        cpf={cpf}
                        email={email}
                        setNome={setNome}
                        setCpf={setCpf}
                        setEmail={setEmail}
                        setPix={setPix}
                        allSoldout={allSoldout}
                        />
                    )}
                    {display===1&&(
                        <PixPayment payload={payload} pixDocId={pixDocId}/>
                    )}
                    {display===2&&(
                        <CardPayment
                        setDisplay={setDisplay}
                        nome={nome}
                        cpf={cpf}
                        email={email}
                        cupom={cupom}
                        preco={preco}
                        labData={labData}
                        webInfo={webInfo}
                        />
                    )}
                    {isMobile&&(<FibraFotos id={2} width={props.width}/>)}

                    <Faq webInfo={webInfo}/>
            {isMobile&&(<FibraFotos id={3} width={props.width}/>)}
            </div>
        </div>
    )
}